function subclip( fullClip, startTime, endTime ) {

    let tracks = [];

    for (let [trackIndex, fullTrack] of fullClip.tracks.entries()) {

        let valueSize = fullTrack.getValueSize();

        let times = [], values = [];
        let { times: fullTimes, values: fullValues } = fullTrack;

        let interpolant = fullTrack.createInterpolant();

        times.push(0);
        values.push(...interpolant.evaluate(startTime));

        let timeIndex = 0;
        while (timeIndex < fullTimes.length && fullTimes[timeIndex] <= startTime) {
            timeIndex++;
        }
        while (timeIndex < fullTimes.length && fullTimes[timeIndex] < endTime) {
            let fullTime = fullTimes[timeIndex];
            times.push(fullTime-startTime);
            values.push(...interpolant.evaluate(fullTime));
            timeIndex++;
        }

        times.push(endTime-startTime);
        values.push(...interpolant.evaluate(endTime));

        let track = new THREE.KeyframeTrack(fullTrack.name, times, values, fullTrack.getInterpolation());
        tracks.push(track);
    }

    return new THREE.AnimationClip(fullClip.name, endTime-startTime, tracks);

}

export default subclip;
